export default "__VITE_ASSET__BJTW6u_a__"